exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".signature-board {\n  width: 300px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  background-color: white;\n  color: gray;\n  border-radius: 6px; }\n  .signature-board:hover {\n    cursor: pointer; }\n\n.custom-signature-pad .change-type {\n  width: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 7px; }\n  .custom-signature-pad .change-type button {\n    border: none;\n    border: none;\n    color: white;\n    background-color: #a4bf43;\n    padding: 7px 30px;\n    border-radius: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/reusableComponents/CustomSignaturePad/customSignaturePad.scss
// module id = 2425
// module chunks = 0